import { render, staticRenderFns } from "./FinalPage.vue?vue&type=template&id=f3f65aa8&"
import script from "./FinalPage.vue?vue&type=script&lang=js&"
export * from "./FinalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports